import React, { useContext, useState } from "react";
import { DataSourceBrowserModal } from "@components/DataSourceBrowser/DataSourceBrowserModal";
import { Select, IconButton } from "uxp/components";
import { hasHistoryEnabledForSource, isDataSource } from "@utils";
import { isSourceConfigurable, ParamsEditor } from "@components/QueryEditor/ParamEditor";
import { QueryBuilderContext } from "@query-builder/QueryBuilderContext";
import './SourceSelectorInput.scss';
export const SourceSelectorInput = props => {
    var _a, _b;
    const { source, onChange, availableSources, history, query } = props;
    const [show, setShow] = useState(false);
    const context = useContext(QueryBuilderContext);
    const $L = (key) => context.uxpContext.$L(key);
    function filterSources() {
        var _a;
        if (history) {
            const _sources = (_a = (availableSources || [])) === null || _a === void 0 ? void 0 : _a.filter(s => isDataSource(s) && hasHistoryEnabledForSource(s));
            return _sources || [];
        }
        return availableSources || [];
    }
    function getAvailableSourceOptions() {
        var _a;
        const _sources = (_a = filterSources()) === null || _a === void 0 ? void 0 : _a.map((s, i) => ({
            label: s.name,
            value: s.id,
            source: s
        }));
        _sources.push({
            label: $L('lqe.ss.add-new-source'),
            value: '__new__',
            source: null
        });
        return _sources || [];
    }
    function handleSourceSelect(option) {
        onChange(option);
        setShow(false);
    }
    function handleOnChange(value, option) {
        if (value == '__new__') {
            setShow(true);
            return;
        }
        handleSourceSelect(option.source);
    }
    return React.createElement("div", { className: "lqe_sourceselctor-ef5f53a2" },
        React.createElement("div", { className: "lqe_sourceselctor-input-ef5f53a2" },
            React.createElement(Select, { selected: source === null || source === void 0 ? void 0 : source.id, onChange: handleOnChange, options: getAvailableSourceOptions() }),
            !!source && isDataSource(source) && isSourceConfigurable(source).isConfigurable ? React.createElement(ParamsEditor, { source: source, onChange: onChange, query: query }) : null),
        React.createElement(DataSourceBrowserModal, { show: show, onClose: () => setShow(false), showCloseButton: true, source: source, onSelect: s => {
                handleSourceSelect(s);
            }, history: history, configuredSources: ((_b = (_a = query === null || query === void 0 ? void 0 : query.sources) === null || _a === void 0 ? void 0 : _a.filter) === null || _b === void 0 ? void 0 : _b.call(_a, s => { var _a; return ((_a = Object.keys((s === null || s === void 0 ? void 0 : s.params) || {})) === null || _a === void 0 ? void 0 : _a.length) > 0; })) || [], query: query }));
};
export const MultipleSourcesSelectorInput = props => {
    const { sources, onChange, availableSources, query } = props;
    const context = useContext(QueryBuilderContext);
    const $L = (key) => context.uxpContext.$L(key);
    function addSource() {
        onChange([...sources, availableSources === null || availableSources === void 0 ? void 0 : availableSources[0]]);
    }
    function removeSource(index) {
        const newSources = [...sources];
        newSources.splice(index, 1);
        onChange(newSources);
    }
    return React.createElement("div", { className: "lucy-query-engine-data-source-selector-ef5f53a2" },
        React.createElement("div", { className: "query-engine-sources-container-ef5f53a2" }, sources.map((source, index) => React.createElement("div", { className: "query-engine-sources-input-ef5f53a2" },
            React.createElement(SourceSelectorInput, { key: index, source: source, onChange: newSource => {
                    const newSources = [...sources];
                    newSources[index] = newSource;
                    onChange(newSources);
                }, availableSources: availableSources, query: query }),
            React.createElement("div", { className: "query-engine-sources-delete-wrap-ef5f53a2" },
                React.createElement(IconButton, { type: 'delete', variant: 'danger', onClick: () => removeSource(index) }))))),
        React.createElement("div", { className: "query-editor-add-source-ef5f53a2", onClick: addSource }, $L('lqe.ss.add-source')));
};
